<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/erp/pricelists"
    >
        <!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div class="pl-4" :alvqa="alvqa + '-title'">
                {{ data.title }}
            </div>
        </template>

        <template v-slot:editForm>
            <v-container fluid>
                <v-row>
                    <v-col cols="6">
                    <!-- Pricelists title -->
                        <BaseEditPageTextField 
                            :context="context"
                            field="Title"
                            :label="$t('lang_ERP_PRICELISTS_CAPTION_TITLE')"
                            :alvqa="alvqa + '-textfield-title'"
                            :clearable="true"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <BaseEditPageTextarea 
                            :context="context" 
                            field="Description"
                            rows="3"
                            :label="$t('lang_ERP_PRICELISTS_CAPTION_DESCRIPTION')" 
                            :alvqa="alvqa + '-textarea-description'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <!-- EDIT FORM -->

        <!-- PANEL  -->
        <template v-slot:panels>
            
            <!-- PRICELISTS ROWS PANEL  -->
            <PricelistsRowsEditPanel />  

            <EditingDialog :context="context + 'PricelistsRows'">
                <template v-slot:editForm>
                    <PricelistsRowsEditPanelDialog />
                </template>
            </EditingDialog>

            <!-- DELETE ROW -->
            <DeletionDialog context="SelectedPricelistsRows" />
          
        </template>

    </BaseEditPage>
</template>

<script>
import BaseEditPage                     from '@/components/_base/BaseEditPage' 
import BaseIcon                         from '@/components/_buttons/BaseIcon'
import BaseButton                       from '@/components/_buttons/BaseButton'

import BaseEditPageTextField            from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea             from '@/components/_editForm/BaseEditPageTextarea'

import SearchDialog                     from '@/components/_dialogs/SearchDialog'
import DeletionDialog                   from '@/components/_dialogs/DeletionDialog'
import EditingDialog                    from '@/components/_dialogs/EditingDialog'

import PricelistsRowsEditPanel          from './_panels/1_pricelistsrows/PricelistsRowsEditPanel'
import PricelistsRowsEditPanelDialog    from './_panels/1_pricelistsrows/PricelistsRowsEditPanelDialog'

export default {
    name: "PricelistsEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseButton,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        SearchDialog,
        DeletionDialog,
        EditingDialog,
        PricelistsRowsEditPanel,
        PricelistsRowsEditPanelDialog,
    },
    data() {
        return {
            context: "Pricelists",
            alvqa: "erp-pricelists-edit-form",
            menu: false,
        }
    },
}
</script>